
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('example-component', require('./components/ExampleComponent.vue'));

require('app-tool');
require('app-mfp');

const app = new Vue({
    el: '#app'
});

$(document).ready(function() {

    $('button.ask-before-delete').on('click',function (e) {
        e.preventDefault();
        ValidationWarning($(this),null,'modal-danger');
    });

    //disable onclick attributes
    $('.ask-before').data('action',$('.ask-before').attr('onclick'));
    $('.ask-before').attr('onclick','');
    $('.ask-before').on('click', function (e) {
        console.log('clicked');
        e.stopPropagation();
        e.preventDefault();
        ValidationWarning($(this),$(this).data('ask'),$(this).data('class'));
    });
});


function ConfirmYesNo( msg,style) {
    var dfd = jQuery.Deferred();

    var $confirm = $('#confirmDelete');

    $confirm.removeClass('modal-warning');
    $confirm.removeClass('modal-danger');
    $confirm.removeClass('modal-success');

    if(style!=undefined){
        $confirm.addClass('modal-'+style);
        $('#confirmTitle').html('Warning');
    }else {
        $confirm.addClass('modal-danger');
        $('#confirmTitle').html('Delete');
    }

    $confirm.modal('show');
    //$('#myModalLabel').html(title);

    $('#confirmText').html(msg);
    $('#confirmDeleteYes').off('click').click(function () {
        $confirm.modal('hide');
        dfd.resolve(1);
        return 1;
    });
    $('#confirmDeleteNo').off('click').click(function () {
        $confirm.modal('hide');
        return 0;
    });
    return dfd.promise();
}

function ValidationWarning($btn,WarningMsg,style) {
    var a = ConfirmYesNo(WarningMsg,style);
    a.then(function (b) {
        //console.log('defered' + b);

        let action = $btn.data('action');
        if(action){
            var x = eval(action)
            if (typeof x == 'function') {
                x()
            }
        }else if($btn.parents('form'))
            $btn.parents('form').submit();

        return true;
    })
}